import TopBar from "../../../components/LayoutComponent/TopBar/topBar";
import Tabbar from "../../../components/LayoutComponent/TabBar/Tabbar";
import "../userDashboard.css";
import UserProfileUpdateComp from "../../../components/userProfileComp/User-Profile-Update-Comp";

export const UserManageProfilePage = () => {
  return (
    <>
      <div className="w3-content" style={{ minHeight: "400px" }}>
        <TopBar
          showBackButton
          displayType="title"
          title="Edit Profile"
          showNotification
        ></TopBar>
        <UserProfileUpdateComp></UserProfileUpdateComp>
        <Tabbar menuType={"users"}></Tabbar>
      </div>
    </>
  );
};

export default UserManageProfilePage;
